import { observer } from 'mobx-react';
import { FC, ReactElement } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import CurbsideNotificationScreen from '../screens/CurbsideNotificationScreen/CurbsideNotificationScreen';
import OrderStatusNotificationEditScreen from '../screens/OrderStatusNotificationEditScreen/OrderStatusNotificationEditScreen';
import OrderStatusNotificationsScreen from '../screens/OrderStatusNotificationsScreen/OrderStatusNotificationsScreen';
import OrderSystemNotificationScreen from '../screens/OrderSystemNotificationScreen/OrderSystemNotificationScreen';
import WalletNotificationEditScreen from '../screens/WalletNotificationEditScreen/WalletNotificationEditScreen';
import WalletNotificationsScreen from '../screens/WalletNotificationsScreen/WalletNotificationsScreen';
import CustomRoute from '~/view/components/CustomRoute/CustomRoute';
import { SCREENS } from 'src/constants/screens';
import { appStore } from '~/mobx/appStore';

const NotificationsSettingRoutes: FC = observer((): ReactElement => {
  return (
    <Switch>
      <Route exact path={SCREENS.SETTINGS_NOTIFICATIONS()}>
        <Redirect to={SCREENS.SETTINGS_NOTIFICATIONS_ORDER_STATUS()} />
      </Route>
      {/* order status */}
      <Route exact path={SCREENS.SETTINGS_NOTIFICATIONS_ORDER_STATUS()} component={OrderStatusNotificationsScreen} />
      <Route path={SCREENS.SETTINGS_NOTIFICATIONS_ORDER_STATUS_CREATE()} component={OrderStatusNotificationEditScreen} />
      {/* order system */}
      <Route exact path={SCREENS.SETTINGS_NOTIFICATIONS_ORDER_SYSTEM()} component={OrderSystemNotificationScreen} />
      {/* wallet */}
      <Route exact path={SCREENS.SETTINGS_NOTIFICATIONS_WALLET()} component={WalletNotificationsScreen} />
      <Route path={SCREENS.SETTINGS_NOTIFICATIONS_WALLET_CREATE()} component={WalletNotificationEditScreen} />
      {/* curbside */}
      <CustomRoute
        exact
        path={SCREENS.SETTINGS_NOTIFICATIONS_CURBSIDE()}
        component={CurbsideNotificationScreen}
        access={appStore.isAddonsAvailable.curbside}
      />
      <Route />
    </Switch>
  );
});

export default NotificationsSettingRoutes;
